module.exports = __webpack_public_path__ + "img/Congo.3f71f780.gif";